import React from "react";
import PropTypes from 'prop-types';
import RenderComponentProto from "../../render-component-proto";

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';

import Classes from "classnames";

export default class EmailField extends RenderComponentProto {

    static props = {
        id: PropTypes.string.isRequired,
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        value: PropTypes.any,
        canEdit: PropTypes.bool,
        onChange: PropTypes.func,
        //old
        params: PropTypes.object,
        onFocusCallback: PropTypes.func,
        onBlurCallback: PropTypes.func,
        stateless: PropTypes.bool // ????
    };

    static defaultProps = {
        canEdit: false
    };

    state = {
        value: this.props.value,
        invalidValue: !gd.utils.validateEmail(this.props.value),
        isEditing: false
    }

    constructor(props) {
        super(props);

        this.commited = true;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.commited && this.state.value !== newProps.value) {
            this.updateValue(newProps.value);
        }
    }

    onFocus = (e) => {
        this.setState({isEditing: true}, ()=> {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur = (e) => {
        this.setState({isEditing: false}, ()=>{
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    onChange = (newValue) => {
        this.commited = true;

        if (!newValue) newValue = '';

        this.setState({value: newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue)
        });
    }

    onImmediateChange = (newValue) => {
        this.commited = false;
        this.updateValue(newValue);
    }

    updateValue = (val) => {
        this.setState({
            value: val,
            invalidValue: !gd.utils.validateEmail(val)
        });
    }

    onCopyClick = () => {
        this.email.select();
        document.execCommand('copy');
        gd.growl.success('Email address copied to clipboard.')
    }

    render() {
        const classes = Classes('gd-field-email gd-custom-field-input-based',this.props.renderMode, {
            'edit': this.state.isEditing,
            // 'invalid-value': this.state.invalidValue,
            'disabled': this.props.canEdit === false,
            'not-set': !this.state.value
        });

        const borderComponent = this.state.value && this.props.renderMode === 'list' && !this.state.isEditing ? <div className="value-border">{this.state.value}</div> : null

        return (
            <div className={classes}>
                <InputInlineEditable ref={r=>this.email = r}
                                     value={this.state.value}
                                     disabled={(this.props.canEdit === false)}
                                     onChange={this.onChange}
                                     onImmediateChange={this.onImmediateChange}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     commitDelay={2000}/>
                <div className="i5-email"/>
                <div className="btn-copy i5-clone" onClick={this.onCopyClick}/>
                {borderComponent}
            </div>
        );
    }
}